import { useMemo } from "react";

import { BaseCheckIcon, BaseHorizontalIcon } from "../Icons";
import { ResponsiveSpinner } from "../ResponsiveSpinner";
import { Typo } from "../Typo";

export const StatusLabel = ({
  label,
  status,
  iconSize = 24,
  textColor = "text-text-secondary",
  textPendingColor = "text-text-disabled",
  isMobile,
}: {
  label: string;
  iconSize?: number;
  textColor?: string;
  textPendingColor?: string;
  isMobile?: boolean;
  status: "pending" | "processing" | "success" | "failed";
}) => {
  const statusIndicator = useMemo(() => {
    switch (status) {
      case "processing":
      case "failed": // Treat "failed" as "pending" for icon purposes
        return (
          <ResponsiveSpinner
            data-testid="ResponsiveSpinner"
            height={iconSize}
            width={iconSize}
          />
        );
      case "success":
        return (
          <BaseCheckIcon
            data-testid="BaseCheckIcon"
            height={iconSize}
            width={iconSize}
          />
        );
      case "pending":
        return (
          <BaseHorizontalIcon
            data-testid="BaseHorizontalIcon"
            height={iconSize}
            width={iconSize}
          />
        );
    }
  }, [iconSize, status]);

  const statusLabelColor = useMemo(() => {
    return status === "pending" ? textPendingColor : textColor;
  }, [status, textColor, textPendingColor]);

  return (
    <span className="flex items-center gap-2 rounded-full">
      {statusIndicator}
      <Typo
        element="span"
        type={isMobile ? "labelSM" : "labelMD"}
        textColor={statusLabelColor}
      >
        {label}
      </Typo>
    </span>
  );
};
